import React, {
  ComponentType,
  useCallback,
  useEffect,
  useState
} from "react";
import SimpleDialogMain from "./index";
import { IBaseProps } from "./types";
import { hot } from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import SimpleDialogActions from "app/actions/simpleDialog.actions";
import StaffNameDialogActions from "app/actions/staffNameDialog.actions";

const NS = 'SimpleDialogMainContainer';

const ThemeWrap = function() {
  const [newProps, setNewProps] = useState<IBaseProps>(null);

  const getClosedObject = (): IBaseProps => ({
    isOpen: false,
    title: '---',
    confirmText: '---',
    rejectText: '---',
    children: null,
    description: '---',
    handleConfirm: () => {},
    handleReject: () => {},
  });

  useEffect(() => {
    handleDialogActions();
  }, []);

  const handleDialogActions = useCallback(() => {
    const isStaffNameRequired = newProps?.staffNameRequired;
    const DialogActions = isStaffNameRequired ? StaffNameDialogActions : SimpleDialogActions;
    
    DialogActions.handleShowDialog((props: IBaseProps) => {
      setNewProps({
        ...props,
        isOpen: true,
        handleConfirm: (staffName : string) => {
          props.handleConfirm(staffName);
          setNewProps(getClosedObject());
        },
        handleReject: () => {
          props.handleReject();
          setNewProps(getClosedObject());
        }
      });
    });

    DialogActions.handleHideDialog(() => {
      setNewProps(getClosedObject());
    });  
  }, [newProps])
 
  return ReactUtilsService.containerWrap(
    <SimpleDialogMain {...newProps} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ASimpleDialogMain: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [] as never[],
  []
];
